const taskTypes = {
  FACEBOOK_CHECKIN: {
    type: 'FACEBOOK_CHECKIN',
    icon: require('@/assets/svg/Facebook-Checkin.svg'),
    verb: 'Checkin',
    company: 'Facebook',
    title: 'Facebook Checkin',
    action: 'Share Checkin',
    urlSlug: 'facebookCheckin',
    route: '/proof/facebookCheckin',
    examples: ['https://storage.googleapis.com/localfluence-library-production/socialPostExamples/postExample-1614821495.png'],
    helpText: {
      socialMention: true,
      socialTags: true,
    },
  },
  FACEBOOK_POST: {
    type: 'FACEBOOK_POST',
    icon: require('@/assets/svg/Facebook.svg'),
    verb: 'Post',
    company: 'Facebook',
    title: 'Facebook Post',
    action: 'Share Post',
    urlSlug: 'facebookPost',
    route: '/proof/facebookPost',
    examples: ['https://storage.googleapis.com/localfluence-library-production/socialPostExamples/postExample-1614821495.png'],
    helpText: {
      socialMention: true,
      socialTags: true,
    },
  },
  INSTAGRAM_POST: {
    type: 'INSTAGRAM_POST',
    icon: require('@/assets/svg/Instagram.svg'),
    verb: 'Post',
    company: 'Instagram',
    title: 'Instagram Post or Story',
    action: 'Upload Screenshot',
    urlSlug: 'instagramPost',
    route: '/proof/instagramPost',
    examples: [
      'https://storage.googleapis.com/localfluence-library-production/socialPostExamples/igPostExample-04262021.png',
      'https://storage.googleapis.com/localfluence-library-production/socialPostExamples/igStoryExample-04262021.jpg',
    ],
    helpText: {
      socialMention: true,
      socialTags: true,
    },
  },
  ONLINE_REVIEW: {
    type: 'ONLINE_REVIEW',
    icon: require('@/assets/svg/Google.svg'),
    verb: 'Review',
    company: 'Google',
    title: 'Google Review',
    action: 'Upload Screenshot',
    urlSlug: 'onlineReview',
    route: '/proof/onlineReview',
    examples: ['https://storage.googleapis.com/localfluence-library-production/socialPostExamples/onlineReviewExample-1614821495.png'],
    helpText: {
      socialMention: false,
      socialTags: false,
      reviewUrl: 'google_address',
    },
  },
  TIK_TOK: {
    type: 'TIK_TOK',
    icon: require('@/assets/svg/TikTok.svg'),
    verb: 'Video',
    company: 'TikTok',
    title: 'TikTok Video',
    action: 'Upload Video',
    urlSlug: 'TikTokPost',
    route: '/proof/TikTokPost',
    examples: [
      'https://storage.googleapis.com/localfluence-library-production/socialPostExamples/GOAT_TikTok_example.jpg',
      'https://storage.googleapis.com/localfluence-library-production/socialPostExamples/PWAT_TikTok_Example.PNG',
      'https://storage.googleapis.com/localfluence-library-production/socialPostExamples/Swig_TikTok_example.jpg',
    ],
    helpText: {
      socialMention: false,
      socialTags: true,
    },
  },
  FACEBOOK_REVIEW: {
    type: 'FACEBOOK_REVIEW',
    icon: require('@/assets/svg/thumbsup_facebook_icon.svg'),
    verb: 'Review',
    company: 'Facebook',
    title: 'Facebook Review',
    action: 'Upload Screenshot',
    urlSlug: 'FacebookReview',
    route: '/proof/facebookReview',
    examples: [
      'https://storage.googleapis.com/localfluence-library-production/socialPostExamples/fb_review_example_1.png',
      'https://storage.googleapis.com/localfluence-library-production/socialPostExamples/fb_review_example_2.png',
      'https://storage.googleapis.com/localfluence-library-production/socialPostExamples/fb_review_example_3.png',
    ],
    helpText: {
      socialMention: false,
      socialTags: false,
      reviewUrl: 'fb_business',
    },
  },
}

export default Object.freeze(taskTypes)
